import { create } from "zustand";
import type { WorkflowUpload } from "./workflow-upload.types";

type WorkflowUploadState = {
	uploads: WorkflowUpload[];
	setUploads: (uploads: WorkflowUpload[]) => void;
	clear: () => void;
};

export const useWorkflowUploadStore = create<WorkflowUploadState>((set) => ({
	uploads: [],
	setUploads: (uploads) => set({ uploads }),
	clear: () => set({ uploads: [] }),
}));
